//
import { ProductModel } from '@/models'

/**
 * 
 */
const fetchAll = async function () {

    //
    try {

        //
        const product = await ProductModel.append( [ 'repacking_children' ] ).params({ get_all_results : true }).where( 'is_repacking_parent', true ).get()

        //
        return product.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default fetchAll
